import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 400px;
	display: flex;
	flex-direction: column;
	user-select: none;
`;

const StyledSectionName = styled.div<{ $color: string; $opacity: number }>`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 20px;

	> img {
		width: 20px;
		height: 20px;
	}

	> div {
		font-family: 'GT Walsheim Pro';
		font-size: 16px;
		color: ${(props) => props.$color};
		line-height: 18px;
		opacity: ${(props) => props.$opacity};
	}
`;

export { StyledContainer, StyledSectionName };
